import React from "react"
import autobind from "class-autobind"
import { Toggle, Card, CardHeader, CardText } from "material-ui"
import strings from "../../localization/strings"
import AppStateStore from "../../stores/AppStateStore"
import * as accountActions from "../../actions/AccountActions"
import { IHierarchyItem, IHierarchyItemSettings, IHierarchyItemForAccountLevel, IJobDocument } from "../../models"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import AccountStore from "../../stores/AccountStore"
import _ from "lodash"
import HierarchyJobVariations from "./hierarchy_job_variations/HierarchyJobVariations"

interface IProps {
    hierarchyJobItem: IHierarchyItem | IHierarchyItemForAccountLevel | IJobDocument
    inheritedHierarchyJobItem: IHierarchyItem | IJobDocument
    readonly: boolean
    handleUpdateJob(job: IJobDocument): Promise<void>
}
interface IState {
    expand: boolean
    isRoot: boolean
    canOverride: boolean
    californiaOvertimeRule: boolean
}

export default class HierarchySettingsOvertime extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            expand: false,
            isRoot: true,
            canOverride: false,
            californiaOvertimeRule: false
        }
        autobind(this)
    }

    componentDidMount() {
        this.checkIsRoot(this.props.hierarchyJobItem)
        this.getCaliforniaOvertimeRule(this.props.inheritedHierarchyJobItem)
    }

    componentWillReceiveProps(nextProps: IProps) {
        !_.isEqual(this.props.hierarchyJobItem, nextProps.hierarchyJobItem) &&
            this.checkIsRoot(nextProps.hierarchyJobItem)
        !_.isEqual(this.props.inheritedHierarchyJobItem, nextProps.inheritedHierarchyJobItem) &&
            this.getCaliforniaOvertimeRule(nextProps.inheritedHierarchyJobItem)
    }

    checkIsRoot(hierarchyJobItem: IHierarchyItemForAccountLevel | IHierarchyItem | IJobDocument) {
        hierarchyJobItem = hierarchyJobItem as IHierarchyItemForAccountLevel
        this.setState({ isRoot: hierarchyJobItem && hierarchyJobItem.level && hierarchyJobItem.level === -1 ? true : false }, () =>
            this.getCanOverride()
        )
    }

    getCanOverride() {
        if (!this.state.isRoot) {
            const hierarchyItem = this.props.hierarchyJobItem as (IHierarchyItem | IJobDocument)
            const inheritedHierarchyJobItemId = this.props.inheritedHierarchyJobItem ? this.props.inheritedHierarchyJobItem.Id : null
            this.setState({ canOverride: hierarchyItem.Id === inheritedHierarchyJobItemId })
        }
        else {
            this.setState({ canOverride: false })
        }
    }

    getCaliforniaOvertimeRule(inheritedHierarchyJobItem: (IHierarchyItem | IJobDocument)) {
        const hierarchySettings = inheritedHierarchyJobItem ?
            inheritedHierarchyJobItem.HierarchyItemSettings :
            AccountStore.getCurrentAccount().HierarchyItemSettings
        this.setState({ californiaOvertimeRule: hierarchySettings.CaliforniaOvertimeRule ? hierarchySettings.CaliforniaOvertimeRule.EnforceCaliforniaOvertimeRule : false })
    }

    handleSave(canOverride, californiaOvertimeRule: boolean) {
        AppStateStore.setProgressSnackbarContent("loading")
        setTimeout(() => {
            this.setState({ canOverride, californiaOvertimeRule }, () =>
                this.state.isRoot ?
                    this.updateAccountCaliforniaOvertimeRule() :
                    this.updateHierarchyJobItemCaliforniaOvertimeRule()
            )
        }, 1000)
    }

    updateAccountCaliforniaOvertimeRule() {
        let hierarchyItemSettings = AccountStore.getCurrentAccount().HierarchyItemSettings
        if (hierarchyItemSettings) {
            hierarchyItemSettings.CaliforniaOvertimeRule = { EnforceCaliforniaOvertimeRule: this.state.californiaOvertimeRule }
        } else {
            hierarchyItemSettings = { CaliforniaOvertimeRule: { EnforceCaliforniaOvertimeRule: this.state.californiaOvertimeRule } } as IHierarchyItemSettings
        }
        accountActions.patchAccountHierarchySettings(AccountStore.getCurrentAccount().Id, { HierarchyItemSettings: hierarchyItemSettings })
    }

    updateHierarchyJobItemCaliforniaOvertimeRule() {
        const hierarchyJobItem = this.props.hierarchyJobItem as (IHierarchyItem | IJobDocument)
        if (this.state.canOverride) {
            if (hierarchyJobItem.HierarchyItemSettings) {
                hierarchyJobItem.HierarchyItemSettings.CaliforniaOvertimeRule = { EnforceCaliforniaOvertimeRule: this.state.californiaOvertimeRule }
            } else {
                hierarchyJobItem.HierarchyItemSettings = { CaliforniaOvertimeRule: { EnforceCaliforniaOvertimeRule: this.state.californiaOvertimeRule } } as IHierarchyItemSettings
            }
        } else {
            if (hierarchyJobItem.HierarchyItemSettings) {
                hierarchyJobItem.HierarchyItemSettings.CaliforniaOvertimeRule = null
            } else {
                hierarchyJobItem.HierarchyItemSettings = { CaliforniaOvertimeRule: null } as IHierarchyItemSettings
            }
        }
        hierarchyJobItem.hasOwnProperty("AccountId") ?
            this.props.handleUpdateJob(hierarchyJobItem as IJobDocument).then(() => AppStateStore.setProgressSnackbarContent(null)) :
            accountActions.updateAccountHierarchyItem(AccountStore.getCurrentAccount().Id, hierarchyJobItem, true)
    }

    render() {
        return (
            <Card
                data-intercom-target={"menu-Hierarchy-Settings-Overtime"}
                expanded={this.state.expand}
                onExpandChange={expand => this.setState({ expand })}
            >
                <CardHeader
                    title={strings.Overtime}
                    subtitle={[
                        <span key="title">
                            {this.state.isRoot ?
                                `(${strings.not_inherited})` :
                                !this.props.inheritedHierarchyJobItem ?
                                    `(${strings.formatString(strings.inherited_from_Account_x, AccountStore.getCurrentAccount().Name)})` :
                                    this.props.inheritedHierarchyJobItem.Id === (this.props.hierarchyJobItem as (IHierarchyItem | IJobDocument)).Id ?
                                        `(${strings.not_inherited})` :
                                        `(${strings.formatString(strings.inherited_from_x, `${hierarchyHelper.getHierarchyDefinitionByHierarchyItemId(this.props.inheritedHierarchyJobItem.Id).Label}:  ${(this.props.inheritedHierarchyJobItem as IHierarchyItem).Label}`)})`
                            }
                        </span>,
                        this.state.expand &&
                        <HierarchyJobVariations
                            key="hierarchy job variations"
                            settingPropertyName="CaliforniaOvertimeRule"
                            hierarchyJobItem={this.props.hierarchyJobItem}
                            inheritedHierarchyJobItem={this.props.inheritedHierarchyJobItem}
                        />
                    ]}
                    actAsExpander={true}
                    showExpandableButton={true}
                    titleStyle={{ fontSize: 20, fontWeight: 500, display: "initial" }}
                    subtitleStyle={{ fontSize: 13, color: "rgb(97, 97, 97)", marginLeft: 10, display: "initial" }}
                />
                <CardText expandable={true}>
                    <div style={styles.body}>
                        {!this.state.isRoot &&
                            <Toggle
                                data-intercom-target={"menu-Hierarchy-Settings-Overtime-Toggle-Override"}
                                label={strings.Override}
                                style={styles.toggle}
                                toggled={this.state.canOverride}
                                disabled={this.props.readonly}
                                onToggle={(e, canOverride) =>
                                    AppStateStore.setConfirmDialogContent({
                                        content: strings.Are_you_sure_you_want_to_change_this_setting_of_hierarchy,
                                        confirm: () => canOverride ?
                                            this.setState({ canOverride }, () => this.updateHierarchyJobItemCaliforniaOvertimeRule()) :
                                            this.handleSave(canOverride, this.state.californiaOvertimeRule)
                                    })
                                }
                            />
                        }
                        {(this.state.isRoot || this.state.canOverride) && !this.props.readonly ?
                            <Toggle
                                data-intercom-target={"menu-Hierarchy-Settings-Overtime-Toggle-CaliforniaOvertime"}
                                label={strings.California_Overtime}
                                style={styles.toggle}
                                toggled={this.state.californiaOvertimeRule}
                                onToggle={(e, value) =>
                                    AppStateStore.setConfirmDialogContent({
                                        content: strings.Are_you_sure_you_want_to_change_this_setting_of_hierarchy,
                                        confirm: () => this.handleSave(this.state.canOverride, value)
                                    })
                                }
                            /> :
                            <div style={{ marginBottom: 22, marginTop: 22 }}>
                                <span>{strings.California_Overtime}</span>
                                <span style={{ marginLeft: 145 }}>{this.state.californiaOvertimeRule ? "True" : "False"}</span>
                            </div>
                        }
                    </div>
                </CardText>
            </Card>
        )
    }
}

const styles = {
    toggle: {
        marginBottom: 20
    },
    body: {
        maxWidth: 300
    },
    titleExpandOn: {
        marginBottom: 30
    },
    titleExpandOff: {
        marginBottom: 0
    }
}